module.exports = __webpack_public_path__ + "img/枢源LOGO02.4f22d897.svg";